import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/article';

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Najnowsze poradniki
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Szczegółowe artykuły i przewodniki, które pomogą Ci w pełni wykorzystać możliwości Kakobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlePreviews.map((preview, index) => (
            <Link
              key={index}
              to={`/artykul/${preview.slug}`}
              className="group rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden"
            >
              <div className="h-44 md:h-48 overflow-hidden">
                <img
                  src={preview.imageUrl}
                  alt={preview.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${preview.badgeClass}`}>
                    {preview.badgeLabel}
                  </span>
                  <span className="text-xs text-foreground-500">{preview.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {preview.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {preview.description}
                </p>
                <div className="mt-4 flex items-center text-sm text-primary-500 font-medium">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:ml-2 transition-all"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-600 border border-primary-200 hover:bg-primary-50 rounded-lg transition-all whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            Zobacz wszystkie poradniki
          </Link>
        </div>
      </div>
    </section>
  );
}